import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BellIcon, SearchIcon, UserIcon, ChevronDownIcon, PlusIcon, MailIcon } from 'lucide-react';
interface TopBarProps {
  onMenuClick: () => void;
  onLogout: () => void;
  isSidebarOpen: boolean;
}
export function TopBar({
  onMenuClick,
  onLogout,
  isSidebarOpen
}: TopBarProps) {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  const [isQuickActionsOpen, setIsQuickActionsOpen] = useState(false);
  const navigate = useNavigate();
  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
    if (isNotificationsOpen) setIsNotificationsOpen(false);
    if (isQuickActionsOpen) setIsQuickActionsOpen(false);
  };
  const toggleNotifications = () => {
    setIsNotificationsOpen(!isNotificationsOpen);
    if (isUserMenuOpen) setIsUserMenuOpen(false);
    if (isQuickActionsOpen) setIsQuickActionsOpen(false);
  };
  const toggleQuickActions = () => {
    setIsQuickActionsOpen(!isQuickActionsOpen);
    if (isUserMenuOpen) setIsUserMenuOpen(false);
    if (isNotificationsOpen) setIsNotificationsOpen(false);
  };
  const handleInboxClick = () => {
    navigate('/inbox');
  };
  return <header className="bg-white border-b border-neutral-200 shadow-sm" data-id="element-668">
      <div className="flex items-center justify-between h-16 px-4" data-id="element-669">
        <div className="flex items-center" data-id="element-670">
          {/* Inbox Icon - Moved to left side */}
          <button className="rounded-full p-1.5 text-neutral-500 hover:bg-neutral-100 focus:outline-none mr-4" onClick={handleInboxClick} title="Go to Inbox" data-id="element-671">
            <MailIcon className="h-6 w-6" data-id="element-672" />
            <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-primary-500 text-xs text-white" data-id="element-673">
              5
            </span>
          </button>
        </div>
        <div className="hidden md:block mx-auto max-w-md w-full px-4" data-id="element-674">
          <div className="relative" data-id="element-675">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-676">
              <SearchIcon className="h-5 w-5 text-neutral-400" data-id="element-677" />
            </div>
            <input type="text" className="w-full rounded-md border border-neutral-300 py-2 pl-10 pr-3 text-base placeholder-neutral-400 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500" placeholder="Search clients, deals, documents..." data-id="element-678" />
          </div>
        </div>
        <div className="flex items-center space-x-3" data-id="element-679">
          {/* Quick Actions Button */}
          <div className="relative" data-id="element-680">
            <button className="btn btn-primary text-sm py-1.5 px-3" onClick={toggleQuickActions} data-id="element-681">
              <PlusIcon className="mr-1.5 h-4 w-4" data-id="element-682" />
              Quick Actions
            </button>
            {/* Quick Actions Dropdown */}
            {isQuickActionsOpen && <div className="absolute right-0 mt-1 w-56 rounded-md bg-white py-1.5 shadow-lg ring-1 ring-black ring-opacity-5 z-50" data-id="element-683">
                <Link to="/leads/new" className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50" data-id="element-684">
                  New Lead
                </Link>
                <Link to="/documents" className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50" data-id="element-685">
                  Upload Document
                </Link>
                <Link to="/settings/templates" className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50" data-id="element-686">
                  Create Pre-Approval Letter
                </Link>
              </div>}
          </div>
          {/* Notifications */}
          <div className="relative" data-id="element-687">
            <button className="rounded-full p-1.5 text-neutral-500 hover:bg-neutral-100 focus:outline-none" onClick={toggleNotifications} data-id="element-688">
              <BellIcon className="h-6 w-6" data-id="element-689" />
              <span className="absolute right-0 top-0 flex h-4 w-4 items-center justify-center rounded-full bg-danger-500 text-xs text-white" data-id="element-690">
                3
              </span>
            </button>
            {/* Notifications Dropdown */}
            {isNotificationsOpen && <div className="absolute right-0 mt-1 w-72 rounded-md bg-white py-1.5 shadow-lg ring-1 ring-black ring-opacity-5 z-50" data-id="element-691">
                <div className="px-4 py-2 text-sm font-medium text-neutral-900" data-id="element-692">
                  Notifications
                </div>
                <div className="border-t border-neutral-100" data-id="element-693">
                  <Link to="/leads/1" className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50" data-id="element-694">
                    <div className="font-medium" data-id="element-695">New lead assigned</div>
                    <div className="text-sm text-neutral-500" data-id="element-696">
                      2 minutes ago
                    </div>
                  </Link>
                  <Link to="/documents" className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50" data-id="element-697">
                    <div className="font-medium" data-id="element-698">Document uploaded</div>
                    <div className="text-sm text-neutral-500" data-id="element-699">1 hour ago</div>
                  </Link>
                  <Link to="/renewals/1" className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50" data-id="element-700">
                    <div className="font-medium" data-id="element-701">Pre-approval expires soon</div>
                    <div className="text-sm text-neutral-500" data-id="element-702">5 hours ago</div>
                  </Link>
                </div>
                <div className="border-t border-neutral-100 px-4 py-2 text-center text-sm font-medium text-primary-600" data-id="element-703">
                  <Link to="/communication" data-id="element-704">View all notifications</Link>
                </div>
              </div>}
          </div>
          {/* User Menu */}
          <div className="relative" data-id="element-705">
            <button className="flex items-center rounded-full text-sm focus:outline-none" onClick={toggleUserMenu} data-id="element-706">
              <div className="h-8 w-8 rounded-full bg-neutral-200 flex items-center justify-center" data-id="element-707">
                <UserIcon className="h-5 w-5 text-neutral-600" data-id="element-708" />
              </div>
              <span className="ml-2 hidden text-sm font-medium text-neutral-700 md:block" data-id="element-709">
                John Broker
              </span>
              <ChevronDownIcon className="ml-1 hidden h-4 w-4 text-neutral-400 md:block" data-id="element-710" />
            </button>
            {/* User Dropdown */}
            {isUserMenuOpen && <div className="absolute right-0 mt-1 w-48 rounded-md bg-white py-1.5 shadow-lg ring-1 ring-black ring-opacity-5 z-50" data-id="element-711">
                <Link to="/settings/organization" className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50" data-id="element-712">
                  Your Profile
                </Link>
                <Link to="/settings/users-roles" className="block px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50" data-id="element-713">
                  Settings
                </Link>
                <button onClick={onLogout} className="block w-full px-4 py-2 text-left text-sm text-neutral-700 hover:bg-neutral-50" data-id="element-714">
                  Sign out
                </button>
              </div>}
          </div>
        </div>
      </div>
    </header>;
}